const videoAutoplay = () => {
    const video = document.querySelector('.template-product .video__player iframe');
    const videoOverlay = document.querySelector('.template-product .video__overlay');
    
    if(video) {
        let videoSrc = video.getAttribute('src');
        if(videoSrc) {
            if(videoSrc.indexOf('controls') === -1 && videoSrc.indexOf('background') === -1) {
                video.setAttribute('src', `${videoSrc}&controls=1&background=0`);
            }
            if((video.getBoundingClientRect().top <= window.innerHeight) && 
            ((video.getBoundingClientRect().bottom + window.innerHeight) > window.innerHeight)) {
                setTimeout(() => {
                    if(videoSrc.indexOf('autoplay') === -1) {
                        video.setAttribute('src', `${videoSrc}&autoplay=1&loop=1&muted=1`);
                    } 
                    if(videoSrc.indexOf('controls') === -1 && videoSrc.indexOf('background') === -1) {
                        video.setAttribute('src', `${videoSrc}&autoplay=1&loop=1&muted=1&background=0&controls=1`);
                    } 
                    videoOverlay.classList.remove('visible');
                }, 300);
            } else {
                videoOverlay.classList.add('visible');
                if(videoSrc.indexOf('autoplay') > -1) {
                    video.setAttribute('src', `${videoSrc.replace('&autoplay=1', '').replace('&muted=1', '').replace('&loop=1', '').replace('&controls=0', '').replace('&background=0', '')}`);
                }
            }
        }
    }
}

window.addEventListener('load', () => {
    videoAutoplay();
})

window.addEventListener('scroll', () => {
    videoAutoplay();
})